import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      colsEnum: {
        4: 4,
        5: 5,
        '5-1': 5
      },
      initialIndex: 0,
      carouselHeights: [],
      isExpand: false,
      showMore: false
    };
  },
  methods: {
    changeDot: function changeDot(index) {
      this.$refs.carousel.setActiveItem(index);
      // this.initialIndex = index
    },
    changeCarousel: function changeCarousel(curIndex) {
      this.initialIndex = curIndex;
    },
    padToLength: function padToLength(arr, length) {
      var padValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (arr.length >= length) return arr.slice();
      return arr.concat(Array(length - arr.length).fill(padValue));
    },
    toEdit: function toEdit(item) {
      if (item.type === 'placeholder') {
        return;
      }
      this.$emit('change', item.index);
    }
  },
  computed: {
    Styles: function Styles() {
      var _this$value$config = this.value.config,
        cols = _this$value$config.cols,
        _this$value$config$ti = _this$value$config.title_font_size,
        title_font_size = _this$value$config$ti === void 0 ? 34 : _this$value$config$ti,
        _this$value$config$ti2 = _this$value$config.title_color,
        title_color = _this$value$config$ti2 === void 0 ? '#333333' : _this$value$config$ti2,
        _this$value$config$ca = _this$value$config.category_font_size,
        category_font_size = _this$value$config$ca === void 0 ? 24 : _this$value$config$ca,
        _this$value$config$ca2 = _this$value$config.category_color,
        category_color = _this$value$config$ca2 === void 0 ? '#333333' : _this$value$config$ca2,
        _this$value$config$ta = _this$value$config.tag_font_size,
        tag_font_size = _this$value$config$ta === void 0 ? 20 : _this$value$config$ta,
        _this$value$config$ta2 = _this$value$config.tag_color,
        tag_color = _this$value$config$ta2 === void 0 ? '#ffffff' : _this$value$config$ta2,
        _this$value$config$bg = _this$value$config.bg_image,
        bg_image = _this$value$config$bg === void 0 ? '' : _this$value$config$bg;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var titleFontSize = title_font_size / baseSize;
      var categoryFontSize = category_font_size / baseSize;
      var tagFontSize = tag_font_size / baseSize;
      return {
        '--templateColumns': this.colsEnum[cols] || cols,
        '--titleFontSize': titleFontSize + 'rem',
        '--titleColor': title_color || '#333333',
        '--categoryFontSize': categoryFontSize + 'rem',
        '--categoryColor': category_color || '#333333',
        '--tagFontSize': tagFontSize + 'rem',
        '--tagColor': tag_color || '#ffffff',
        '--bgImage': "url(".concat(bg_image, ")")
      };
    },
    iconContentClass: function iconContentClass() {
      var _this$value$config2 = this.value.config,
        bg_style = _this$value$config2.bg_style,
        border_style = _this$value$config2.border_style,
        border_none = _this$value$config2.border_none;
      var className = [];
      if (bg_style !== 2) {
        return className.join(' ');
      }
      className.push('border');
      if (border_style == '2') {
        var enumClass = {
          1: 'top',
          2: 'right',
          3: 'bottom',
          4: 'left'
        };
        var borderNoneList = border_none.map(function (i) {
          return "border-hide-".concat(enumClass[i]);
        });
        className = className.concat(borderNoneList);
      }
      return className.join(' ');
    },
    swiperValues: function swiperValues() {
      var _this$value$config3 = this.value.config,
        _this$value$config3$v = _this$value$config3.value,
        value = _this$value$config3$v === void 0 ? [] : _this$value$config3$v,
        total_cols = _this$value$config3.total_cols,
        _this$value$config3$c = _this$value$config3.cols,
        cols = _this$value$config3$c === void 0 ? 5 : _this$value$config3$c,
        fold_start_row = _this$value$config3.fold_start_row,
        is_open_row_fold = _this$value$config3.is_open_row_fold;
      if (!Array.isArray(value)) {
        return [];
      }
      cols = this.colsEnum[cols] || cols;
      total_cols = total_cols || cols;
      var valueList = value.map(function (i, index) {
        return _objectSpread(_objectSpread({}, i), {}, {
          index: index
        });
      });
      var screenIndex = 0;
      var screenLength = Math.ceil(total_cols / cols);
      var rows = Array.from({
        length: screenLength
      }, function () {
        return [];
      });
      if (screenLength > 1) {
        while (valueList.length) {
          var sliceNumber = cols;
          if (screenIndex + 1 === screenLength) {
            sliceNumber = total_cols % cols || cols;
          }
          var data = valueList.splice(0, sliceNumber);
          if (data.length) {
            var _rows$screenIndex;
            data = this.padToLength(data, cols, {
              type: 'placeholder'
            });
            (_rows$screenIndex = rows[screenIndex]).push.apply(_rows$screenIndex, _toConsumableArray(data));
          }
          screenIndex++;
          if (screenIndex === screenLength) {
            screenIndex = 0;
          }
        }
      } else {
        var _rows$screenIndex2;
        (_rows$screenIndex2 = rows[screenIndex]).push.apply(_rows$screenIndex2, _toConsumableArray(valueList));
      }
      var eleNumber = rows[this.initialIndex].length;
      var hideRow = fold_start_row - 1;
      this.showMore = is_open_row_fold === '1' && eleNumber > cols * hideRow;
      if (this.showMore && !this.isExpand) {
        rows[this.initialIndex] = rows[this.initialIndex].slice(0, cols * hideRow);
      }
      return rows.filter(function (i) {
        return i.length;
      });
    },
    carouselHeight: function carouselHeight() {
      return this.carouselHeights[this.initialIndex];
    }
  },
  watch: {
    swiperValues: {
      handler: function handler(val) {
        var _this = this;
        if (val) {
          this.$nextTick(function () {
            var _this$$refs$icon_drag;
            // const baseSize = 16
            // const currentSize = document.documentElement.style.fontSize.replace(
            // 	/[^0-9.]/g,
            // 	''
            // )
            _this.carouselHeights = (_this$$refs$icon_drag = _this.$refs.icon_draggable) === null || _this$$refs$icon_drag === void 0 ? void 0 : _this$$refs$icon_drag.map(function (i) {
              // return `${i.clientHeight / currentSize}rem`
              return "".concat(i.clientHeight, "px");
            });
          });
        }
      },
      immediate: true
    }
  }
};